import { Component, Inject, Input, OnInit } from '@angular/core';
//import { runInThisContext } from 'vm';
import { MonthlyDashboardMessageVM } from '../../entities/global/model';
import { SafetyConfigService } from '../../services/safety-config.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-monthly-alert-dialog',
  templateUrl: './monthly-alert-dialog.component.html',
  styleUrls: ['./monthly-alert-dialog.component.css']
})
export class MonthlyAlertDialogComponent implements OnInit {
  FocusItems
  AreasImprovement
  Positives
  Take5Target:number=0
  SafetyInspTarget:number=0
  @Input() Month: number; 
  @Input() Year: number; 

 //labels
  FocusItemsValue
  AreasImprovementValue
  PositivesValue
  Take5TargetValue
  safetyInspectionValue
  InputStateValue

  model_:MonthlyDashboardMessageVM;
  res_:MonthlyDashboardMessageVM; 

  constructor(public dialogRef:MatDialogRef<MonthlyAlertDialogComponent>,
    private _safetyConfigService:SafetyConfigService,
    @Inject(MAT_DIALOG_DATA) public _data: any) { }

  ngOnInit() {    
      this.model_ = this._data.model;
      this.res_=this._data.model;
      this.check();

   
  }
  DialogClose(){
    this.dialogRef.close(false)
  }

  save()
  {
  
    this._safetyConfigService.addMonthlyDashboardMessage(this.model_).subscribe(r=>{
      console.log('saved')
  });
  this.dialogRef.close(false)
}

check()
{
  this._safetyConfigService.checkMonthlyDashboardMessagesubmit(this.res_).subscribe(r=>{
    this.FocusItemsValue=r[0].FocusItems;
    this.AreasImprovementValue=r[0].AreasImprovement;
    this.PositivesValue=r[0].Positives;
    this.Take5TargetValue=r[0].Take5Target;
    this.safetyInspectionValue=r[0].SafetyInspTarget;
   // this.InputStateValue=r[0].s
    
    console.log( ' checked work')
    
});
}

}
